import React from 'react'
import PropTypes from 'prop-types'
import { BLOCK_LABELS, formatNumber } from './blockConfig'

function BlockSummaryBar({ blocks, onExpandBlock }) {
    return (
        <div className="BlockSummaryBar d-flex mb-3">
            {blocks.map((b) => {
                const label = BLOCK_LABELS[b.block]
                return (
                    <div
                        key={b.block}
                        className={`SummaryCard ${label.emphasize ? 'Emphasized' : ''}`}
                        onClick={() => onExpandBlock(b.block)}
                    >
                        <div className="Label">{label.title}</div>
                        <div className="TotalNumber">{formatNumber(b.total)}</div>
                        <div className="Meta">
                            {formatNumber(b.skuCount)} SKU
                            {b.overdueCount > 0 && (
                                <span className="OverdueCount"> · {formatNumber(b.overdueCount)} quá hạn</span>
                            )}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

BlockSummaryBar.propTypes = {
    blocks: PropTypes.array.isRequired,
    onExpandBlock: PropTypes.func.isRequired,
}

export default BlockSummaryBar
